import React from "react";
import { Balancer } from "react-wrap-balancer";
import { Text } from "@chakra-ui/react";
import { type Integration } from "lib/sanity";
import { Section } from "components/section";
import { AnimatedAccordion } from "components/animated-accordion";
import { integrationsCount, sourcesCount } from "../../constants/integrations";
import accordionImage1 from "../../../public/assets/activate-data-steps/accordion-1.png";
import accordionImage2 from "../../../public/assets/activate-data-steps/accordion-2.png";
import accordionImage3 from "../../../public/assets/activate-data-steps/accordion-3.png";
import { Step3Figure } from "./step-3/step-3-figure";

type ActivateDataProps = {
  source?: Integration;
  destination?: Integration;
};

function ActivateDataSteps({ source, destination }: ActivateDataProps) {
  const useFigure3 = source && destination;
  return (
    <Section>
      <Text as="h2" textStyle="h4" textAlign={{ base: "center", md: "left" }} mb={16}>
        <Balancer> Activate your data in 3 easy steps</Balancer>
      </Text>

      <AnimatedAccordion
        align="left"
        items={[
          {
            image: accordionImage1,
            imageAlt: "Logos of sources connecting to destination logos.",
            eyebrow: "Step 1",
            label: "Connect your source and destination",
            content: `Connect to ${sourcesCount}+ data sources, like ${
              source?.name ?? "Snowflake"
            }, and ${integrationsCount}+ destinations, like ${destination?.name ?? "Salesforce"}.`,
          },
          {
            image: accordionImage2,
            imageAlt: "dbt users model with SQL query.",
            eyebrow: "Step 2",
            label: "Define your model",
            content: "Use SQL or select an existing dbt or Looker model.",
          },
          {
            customFigure: useFigure3 ? <Step3Figure source={source} destination={destination} /> : undefined,
            image: useFigure3 ? undefined : accordionImage3,
            imageAlt: "Field mapping from source to destination.",
            eyebrow: "Step 3",
            label: "Sync your data",
            content: `Map your fields, set your sync schedule, and hit “Go!”`,
          },
        ]}
      />
    </Section>
  );
}

export default ActivateDataSteps;
